export const ACTION_TYPES = {
  AGGREGATE_QUERY_SUCCESS: 'AGGREGATE_QUERY_SUCCESS',
  DELETE_REPORT_SUCCESS: 'DELETE_REPORT_SUCCESS',
  CREATE_REPORT_SUCCESS: 'CREATE_REPORT_SUCCESS',
  UPDATE_REPORT_SUCCESS: 'UPDATE_REPORT_SUCCESS',
  EXPORT_REPORT_REQUEST: 'EXPORT_REPORT_REQUEST',
  EXPORT_REPORT_REQUEST_SUCCESS: 'EXPORT_REPORT_REQUEST_SUCCESS',
  EXPORT_REPORT_REQUEST_FAILURE: 'EXPORT_REPORT_REQUEST_FAILURE',
  GET_REPORT_SUCCESS: 'GET_REPORT_SUCCESS',
  GET_REPORTS_BATCH_SUCCESS: 'GET_REPORTS_BATCH_SUCCESS',
  PREVIEW_TASKS_REQUEST: 'PREVIEW_TASKS_REQUEST',
  PREVIEW_TASKS_REQUEST_SUCCESS: 'PREVIEW_TASKS_REQUEST_SUCCESS',
  PREVIEW_TASKS_REQUEST_FAILURE: 'PREVIEW_TASKS_REQUEST_FAILURE',
};
